import { combineReducers } from 'redux';
import { AppState } from 'types/AppState';
import { scenes } from './scenes';
import { downloading } from './downloading';
import { activeTool } from './activeTool';
import { transitions } from './transitions';
import { alert } from './alert';
import { ratioFormat } from './ratioFormat';
import { scenesCreationProgress } from 'modules/scenesCreationProgress';
import { user } from 'modules/user';
import { currentTextId } from './currentTextId';
import { canvas } from './canvas';
import { effects } from './effects';
import { userSongs } from './userSongs';
import { sceneVolume } from './sceneVolume';
import { audio } from './audio';
import { checkoutModal } from './checkoutModal';
import { settings } from './settings';
import { replaceSceneContent } from './replaceSceneContent';
import { applyTemplate, template } from './template';
import reduceReducers from 'reduce-reducers';
import { createReducer } from 'deox';
import { scenesDownloadingProgress } from 'modules/sceneDownloadingProgress';
import { sidebar } from 'modules/sidebar';
import { workspace } from 'modules/workspace';
import { shortcutsPopup } from 'modules/shortcutsPopup';
import { scenesSources } from 'modules/scenesLoader';
import { applyProject, projectFiles } from 'modules/projectFles';
import { filters } from 'modules/filters';
import { revisions } from 'modules/./revisions';
import { persistedSettings } from 'modules/persistedSettings';
import { oneTimePayment } from 'modules/oneTimePayment';

export const baseReducer = combineReducers<AppState>({
  settings,
  audio,
  scenes,
  downloading,
  activeTool,
  transitions,
  alert,
  ratioFormat,
  scenesCreationProgress,
  scenesDownloadingProgress,
  user,
  currentTextId,
  canvas,
  effects,
  checkoutModal,
  userSongs,
  sceneVolume,
  replaceSceneContent,
  template,
  sidebar,
  workspace,
  shortcutsPopup,
  scenesSources,
  projectFiles,
  filters,
  revisions,
  persistedSettings,
  oneTimePayment
});

const featureReducers = createReducer({}, handle => [
  handle(applyTemplate, (app: AppState, { payload }) => {
    return {
      ...app,
      ...payload
    };
  }),
  handle(applyProject, (app: AppState, { payload }) => {
    return {
      ...app,
      ...payload
    };
  })
]);

export const reducer = reduceReducers(baseReducer, featureReducers);
